import {SRC, srcRef} from "/@lib@/wsp/src.js";
import {WSP} from "/@lib@/wsp/wsp.js";
import {SrcPointer, SrcPointerFastSelect, SrcPointerSetterAction} from "/@back@/wsp/widgets/srcDrawer.js";
import {Button, OButtonInit} from "/@back@/commons/widgets/buttons.js";
import {Action, ActionSeparator, IAction} from "/@lib@/commons/actions.js";
import {POPUP} from "/@back@/commons/widgets/popups.js";
import {JLastDatas} from "/@lib@/commons/lastDatas.js";

/**
 */
export interface SrcHisto extends Button {
	initialize(init: OSrcHistoInit): this
}

export interface OSrcHistoInit extends OButtonInit {
	srcPointer?: SrcPointer
	history?: srcRef[]
}

export class SrcHisto extends Button {

	srcPointer: SrcPointer
	protected histoSet: Set<srcRef>;

	setHistory<LD extends JLastDatas>(parent: LD, key: keyof LD): LD | undefined {
		if (this.histoSet.size > 0) {
			parent[key] = [...this.histoSet] as any;
			return parent;
		}
	}

	protected _initialize(init: OSrcHistoInit) {
		//if(!("icon" in init) init.icon = ""; TODO centraliser icone
		this.srcPointer = init.srcPointer;
		this.histoSet = new Set(init.history);
		super._initialize(init);
		this.onclick = this.onClick;
		this.srcPointer.onSrcRefChange.add(() => {this.addEntryHisto(this.srcPointer.srcRef)});
		if (init.history?.length > 0) this.srcPointer.setSrcRef(init.history[init.history.length - 1]);
	}

	addEntryHisto(srcRef: srcRef) {
		if (!srcRef) return;
		this.histoSet.delete(srcRef); //pour le replacer à la fin si il était déjà dans la liste.
		if (this.histoSet.size > 12) {
			let del = 0;
			for (const s of this.histoSet) {
				this.histoSet.delete(s);
				if (++del === 12) break;
			}
		}
		this.histoSet.add(srcRef);
	}

	protected async onClick(ev: MouseEvent) {
		const reg = this.srcPointer.reg;
		const actions: IAction<SrcPointer>[] = [];
		if (this.histoSet.size > 1) {
			const srcRefs = Array.from(this.histoSet);
			if (this.srcPointer.srcRef) srcRefs.length--; //on suppr le dernier courant
			const srcs = await WSP.fetchShortDescs(reg.env.wsp, this, ...srcRefs);
			for (const src of srcs) {
				if (src) {
					if (src.srcSt > 0 && src.itModel != null) actions.push(new SrcPointerSetterAction(src));
					else this.histoSet.delete(SRC.srcRef(src)); // src supprimée, cleanup
				}
			}
		}
		if (actions.length === 0) actions.push(new Action<SrcPointer>('none').setEnabled(false).setLabel("Historique vide"));
		else actions.reverse();
		actions.push(
			new ActionSeparator(),
			new SrcPointerFastSelect("selOther" /*Autre id pour tuer accelKey*/).setLabel("Autre item...")
		);
		return POPUP.showPopupActionsFromEvent({
			reg,
			actions,
			actionContext: this.srcPointer
		}, ev);
	}
}

customElements.define('wsp-src-histo', SrcHisto);